import React from 'react';
import { Input, Select } from '@chiroup/components';
import { COUNTRIES } from '../../constants';
import { ValueOf } from '@chiroup/core/types/ValueOf.type';
import {
  CANADIAN_PROVINCES,
  STATES,
} from '@chiroup/core/constants/UsStatesAndTerritories';
import { FormErrors } from '@chiroup/core/types/ErrorResponse.type';
import { SeminarSignupForm } from '@chiroup/core/types/Seminar.type';

type Props = {
  value: Partial<SeminarSignupForm>;
  onChange: (
    key: keyof Partial<SeminarSignupForm>,
  ) => (val: ValueOf<SeminarSignupForm>) => void;
  errors?: FormErrors;
};

const SeminarClinicFormFields: React.FC<Props> = ({
  value,
  onChange,
  errors,
}) => {
  const { name, address1, city, state, zip, country } = value ?? {};

  return (
    <>
      <div className="flex flex-col md:flex-row md:space-x-4">
        <div className="md:w-1/2">
          <Input
            name="clinicName"
            value={name}
            onChange={onChange('name')}
            label="Clinic Name *"
            className="pb-2"
            errors={errors?.fieldErrors?.name}
          />
        </div>
        <div className="md:w-1/2">
          <Input
            name="address1"
            value={address1}
            onChange={onChange('address1')}
            label="Street Address *"
            className="pb-2"
            errors={errors?.fieldErrors?.address1}
          />
        </div>
      </div>

      <div className="flex flex-col md:flex-row md:space-x-4">
        <Select
          name="country"
          label="Country *"
          options={COUNTRIES}
          value={country}
          onChange={onChange('country')}
          errors={errors?.fieldErrors?.country}
          className="w-full"
          limit={1}
          native
        />
      </div>
      <div className="flex flex-col md:flex-row md:space-x-4">
        <div className="pb-2 md:w-1/3">
          <Input
            name="city"
            value={city}
            onChange={onChange('city')}
            label="City *"
            className="pb-2"
            errors={errors?.fieldErrors?.city}
          />
        </div>
        <div className="pb-2 md:w-1/3">
          {['USA', 'CAN'].includes(country || '') ? (
            <Select
              name="state"
              className="sm:col-span-4"
              label={`${country === 'CAN' ? 'Province *' : 'State *'}`}
              value={state}
              onChange={onChange('state')}
              errors={errors?.fieldErrors?.state}
              options={country === 'CAN' ? CANADIAN_PROVINCES : STATES}
              limit={1}
              autocomplete
            />
          ) : (
            <Input
              name="state"
              className="sm:col-span-4"
              label="State/Province *"
              value={state}
              onChange={onChange('state')}
              errors={errors?.fieldErrors?.state}
            />
          )}
        </div>
        <div className="pb-2 md:w-1/3">
          <Input
            name="zip"
            value={zip}
            onChange={onChange('zip')}
            label="Zip Code *"
            className="pb-2"
            errors={errors?.fieldErrors?.zip}
          />
        </div>
      </div>
    </>
  );
};

export default SeminarClinicFormFields;
